import { useAuth } from "../components/context/AuthContext";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const { user, token, loading } = useAuth();

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (!token || !user) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
